import React, { useState, useEffect } from 'react';
//import { Home, FileText, ClipboardList, User, Menu } from 'lucide-react';
// import { FileCheck, FileClock, UserCheck,Settings,User } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AuthData } from "../../auth/AuthWrapper"
import CommonIcon from '../common/customicon';
import { Link,useLocation} from 'react-router-dom'; // Import Link from react-router-dom
import { LayoutPanelTop,FileCode,CircleChevronLeft,FileText, LayoutGrid, ClipboardList, File, Settings, Menu,FileCheck, FileClock,UserCheck,User, CircleChevronRight} from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { getUsername,getInitials } from "../../utils/common_functions";
import { apiCall } from "../../utils/server_utils";
import Message from "../common/message";
import { API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import PageLoader from '../common/pageloader';
import * as ReactDOM from 'react-dom';
import {trackError} from "../../utils/error_tracker"
import Sidebar from '../structure/sidebar'; 

const data1 = [
  { "month": 'Jan', "requirement_count": 4, "techsepecs_count": 3 },
  { "month": 'Feb', "requirement_count": 7, "techsepecs_count": 5 },
  { "month": 'Mar', "requirement_count": 9, "techsepecs_count": 7 },
  { "month": 'Apr', "requirement_count": 12, "techsepecs_count": 9 },
  { "month": 'May', "requirement_count": 15, "techsepecs_count": 11 },
  { "month": 'Jun', "requirement_count": 18, "techsepecs_count": 14 },
];

const graphdata = [
  { name: 'Jan', documents: 4, techSpecs: 3 },
  { name: 'Feb', documents: 7, techSpecs: 5 },
  { name: 'Mar', documents: 9, techSpecs: 7 },
  { name: 'Apr', documents: 12, techSpecs: 9 },
  { name: 'May', documents: 15, techSpecs: 11 },
  { name: 'Jun', documents: 18, techSpecs: 14 },
];


// 🧩 Reusable NavItem component with hover tooltip
const NavItem = ({ to, icon, label, isSidebarOpen }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `group relative flex items-center p-2 rounded hover:bg-gray-700 transition-all duration-200 ${
        isSidebarOpen ? "justify-start" : "justify-center"
      } ${isActive ? "bg-white text-black font-medium" : "text-white"}`
    }
  >
    {icon}
    {isSidebarOpen ? (
      <span className="ml-2">{label}</span>
    ) : (
      <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 shadow-lg">
        {label}
      </span>
    )}
  </NavLink>
);

export const Overview = () => {
  //const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
      // Initialize from localStorage, default to false
      const saved = localStorage.getItem('isSidebarOpen');
      return saved === 'true';
    });
  
    // Update localStorage whenever isSidebarOpen changes
    useEffect(() => {
      localStorage.setItem('isSidebarOpen', isSidebarOpen);
    }, [isSidebarOpen]);
  const { user, isLoggedIn, logout } = AuthData();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // API data for documents

  useEffect(() => {
      // Fetch data from the API
      const fetchWidget = async () => {
          setLoading(true); // Stop loading spinner
        try {
          const result = await apiCall("GET", `${API_SERVER_URL}overview/`);
          if (result.code === API_SUCCESS_RESPONSE_CODE) {
            setData(result.data);
            setLoading(false);  
          }
        } catch (error) {
          setLoading(false);  
          console.error("Error fetching contracts", error);
        }
      };
      fetchWidget();
    }, []);


  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar logout={logout} isSidebarOpen={isSidebarOpen} />
     

      {/* Main Content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-24'}`}>

      <button
  className="absolute ml-[-10px] top-4  flex items-center justify-center rounded-full text-white bg-blue-500 hover:bg-blue-600 z-50"
  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
>
  {isSidebarOpen ? (
    <CircleChevronLeft className="w-5 h-5" />
  ) : (
    <CircleChevronRight className="w-5 h-5" />
  )}
</button>

        <header className="flex items-center justify-between p-4 bg-white shadow md:pl-6">
          <button
            className="md:hidden p-2 rounded text-gray-700 hover:bg-gray-200"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            <Menu className="w-6 h-6" />
          </button>
          <div >
        <h1 className="text-2xl font-bold">Overview</h1>
        <p className="mt-2 text-gray-600">Dashboard for document and specification metrics</p>
      </div>
        </header>

        <main className="flex-1 p-6 bg-gray-100 overflow-y-auto">
          {/* Overview Cards */}
                   {loading ? (
                           <PageLoader />
                      ) :
          <>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            {
            // [
            //   { title: 'Total Documents', count: 42,icon: FileText,
            //     color: 'bg-blue-100 text-blue-800' },
            //   { title: 'Completed Tech Specs', count: 28, rate: '66% completion rate',icon: FileCheck,
            //     color: 'bg-green-100 text-green-800' },
            //   { title: 'In Progress', count: 14, description: 'Tech specs being drafted',icon: FileClock,
            //     color: 'bg-amber-100 text-amber-800' },
            //   { title: 'Active Users', count: 8, description: 'Contributing this month',icon: UserCheck,
            //     color: 'bg-purple-100 text-purple-800' },
            // ]
            
            data.widgets!==undefined ? 
            data.widgets.map((item, index) => (
              <div key={index} className="bg-white p-4 rounded-2xl shadow-md text-center">
                <NavLink
               to=
               {
               item.title === "Total Documents" 
               ? 
               "/tech-spec" : 
               item.title === "Completed Tech Specs" ?
               "/tech-spec" :"/"
              }
             > 
              <div className="flex items-center justify-between">
                
                  <div>
                    <p className="text-sm font-medium text-gray-500">{item.title}</p>
                    <p className="text-3xl font-bold">{item.count}</p>
                    <p className="text-xs text-gray-500 mt-1">{item.description}</p>
                  </div>
                  <div className={`p-3 rounded-full bg-blue-100 text-blue-800 ${item.color}`}>
                   { item.icon === "FileText" ?
                    <FileText className="h-5 w-5" /> :
                    item.icon === "ClipboardList" ? 
                    <ClipboardList className="h-5 w-5" /> :
                    item.icon === "User" ? 
                    <User className="h-5 w-5" /> :""
                   }
                  </div>
                </div>
                </NavLink>
                </div>
            ))
            :""
          }
          </div>

          {/* Document Activity Chart */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

            <div className="col-span-1 bg-white shadow rounded-xl p-4">
              <div className="border-b pb-2 mb-4">
                <h2 className="text-lg font-bold">Document Activity</h2>
                <p className="text-sm text-gray-500">
                  Documents and tech specs created over time
                </p>
              </div>
              <div className="h-80">
              { 
                data.document_activity!==undefined ? 
                 <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={data.document_activity}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="requirement_count" fill="#0a2f6c" name="requirement_count" />
                    <Bar dataKey="techsepecs_count" fill="#3b82f6" name="techsepecs_count" />
                  </BarChart> 
                </ResponsiveContainer> : "" 
              }  
              </div>
            </div>

          <div class="col-span-1 bg-white shadow rounded-xl p-4">
            <div class="pb-4 mb-4 border-b border-gray-200">
              <h2 class="text-lg font-bold">Recent Activity</h2>
              <p class="text-sm text-gray-500">Latest updates on documents and specifications</p>
            </div>
            <div class="space-y-4">
              
            {
              // [
              //     'Tech specification completed - AWS Infrastructure Specs - 1 hour ago',
              //     'New requirement document added - GDPR Compliance Requirements - 2 hours ago',
              //     'Tech specification completed - AWS Infrastructure Specs - 3 hours ago',
              //     'New requirement document added - GDPR Compliance Requirements - 4 hours ago',
              //     'Tech specification completed - AWS Infrastructure Specs - 5 hours ago',
              //   ]
                
                data.recent_activity != undefined ? 
                data.recent_activity.map((activity, index) => (

              <div class="flex items-start gap-4 pb-4 border-b border-gray-100">
                <div class="p-2 rounded-full bg-blue-100 text-blue-800">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 110-16 8 8 0 010 16zm-1-11h2v5h-2v-5zm0 6h2v2h-2v-2z"/>
                  </svg>
                </div>
                <div>
                  <p class="font-medium text-sm">{activity.title}</p>
                  <p class="text-xs text-gray-500">{activity.fileName} - {activity.userName} - {activity.duration}</p>
                </div>
              </div>

              ))
                 : "" }

            </div>
          </div>
          </div>
          </>  }
        </main>
      </div>
    </div>
  );
};